import {
  BzitResponse,
  BzitSearchParameters,
  ServiceResult
} from '../../bzit';
import { SEARCH_URL } from '../../configs/env';
import { fetchJson } from '../../utils/fetch';

export interface GetParametersArgs {
  countryId?: string;
}

export const getParameters = async ({
  countryId = ''
}: GetParametersArgs): Promise<ServiceResult<BzitSearchParameters>> => {
  try {
    const result = await fetchJson<BzitResponse<BzitSearchParameters>>(
      `${SEARCH_URL}searchParameter${countryId ? '/' + countryId : ''}`,
      {
        method: 'POST',
        mode: 'cors'
      }
    );
    if (result.resultCode === 0) {
      return { success: true, result };
    }
    throw new Error();
  } catch (error) {
    return { success: false, error };
  }
};
